@if (shouldShowBanner()) {
  <ht-banner [type]="bannerType" (closed)="onBannerClosed()">
    <span banner-content class="addons-announcement-banner__content">
      <span class="addons-announcement-banner__icon">🚀</span>
      <span class="addons-announcement-banner__text">
        Introducing our new features – explore them in our 'Add-On page'.
      </span>
    </span>
    <button
      ht-button-primary
      appearance="minimal"
      size="small"
      banner-action
      (click)="onExploreClick()"
    >
      Explore now
    </button>
  </ht-banner>
}
